/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  BigNumberish,
  Overrides,
} from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type {
  Archetype_Vault,
  Archetype_VaultInterface,
} from "../Archetype_Vault";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_wNat",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_remainPerNFT",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_unlockUntil",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "CSM",
    outputs: [
      {
        internalType: "contract IClaimSetupManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "Dist",
    outputs: [
      {
        internalType: "contract IDistributionToDelegators",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "NFTContract",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "activeAutoClaim",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "claimFlareDrop",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "claimReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "currentDelegatees",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "delegatable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "delegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[2]",
        name: "delegatee",
        type: "address[2]",
      },
    ],
    name: "delegateTo",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "depositERC20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "depositETH",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "executors",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ftsoManager",
    outputs: [
      {
        internalType: "contract IFtsoManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ftsoRewardManager",
    outputs: [
      {
        internalType: "contract IFtsoRewardManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "getClaimableAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getFeeForExecutors",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "getTokenInfo",
    outputs: [
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "string",
            name: "tokenName",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "claimedAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "remainPerNFT",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "unlockTimestamp",
            type: "uint256",
          },
        ],
        internalType: "struct Archetype_Vault.Token",
        name: "tokenInfo",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTokenList",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "removeToken",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_claimManager",
        type: "address",
      },
    ],
    name: "setClaimSetupManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_dist",
        type: "address",
      },
    ],
    name: "setDistributionToDelegators",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_executors",
        type: "address[]",
      },
    ],
    name: "setExecutors",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_ftsoManager",
        type: "address",
      },
    ],
    name: "setFtsoManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_ftsoRewardManager",
        type: "address",
      },
    ],
    name: "setFtsoRewardManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_intervalEpochs",
        type: "uint256",
      },
    ],
    name: "setIntervalEpochs",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_num",
        type: "uint256",
      },
    ],
    name: "setMaxDelegatableNumber",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_maxSupply",
        type: "uint256",
      },
    ],
    name: "setMaxSupply",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftContract",
        type: "address",
      },
    ],
    name: "setNFTContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "string",
        name: "_tokenName",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "_remainPerNFT",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_lockedUntil",
        type: "uint256",
      },
    ],
    name: "setTokenERC20",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IVote4Delegation",
        name: "_votingContract",
        type: "address",
      },
    ],
    name: "setVotingContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_wNat",
        type: "address",
      },
      {
        internalType: "string",
        name: "_tokenName",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "_remainPerNFT",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_lockedUntil",
        type: "uint256",
      },
    ],
    name: "setWNat",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokenList",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "tokens",
    outputs: [
      {
        internalType: "string",
        name: "tokenName",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "claimedAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "remainPerNFT",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "unlockTimestamp",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_from",
        type: "address",
      },
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_balance",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_nftId",
        type: "uint256",
      },
    ],
    name: "transferNFTAssets",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "wNat",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_wrap",
        type: "bool",
      },
    ],
    name: "withdraw",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawAllTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "withdrawERC20",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "wrap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type Archetype_VaultConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: Archetype_VaultConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Archetype_Vault__factory extends ContractFactory {
  constructor(...args: Archetype_VaultConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _wNat: PromiseOrValue<string>,
    _remainPerNFT: PromiseOrValue<BigNumberish>,
    _unlockUntil: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<Archetype_Vault> {
    return super.deploy(
      _wNat,
      _remainPerNFT,
      _unlockUntil,
      overrides || {}
    ) as Promise<Archetype_Vault>;
  }
  override getDeployTransaction(
    _wNat: PromiseOrValue<string>,
    _remainPerNFT: PromiseOrValue<BigNumberish>,
    _unlockUntil: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _wNat,
      _remainPerNFT,
      _unlockUntil,
      overrides || {}
    );
  }
  override attach(address: string): Archetype_Vault {
    return super.attach(address) as Archetype_Vault;
  }
  override connect(signer: Signer): Archetype_Vault__factory {
    return super.connect(signer) as Archetype_Vault__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): Archetype_VaultInterface {
    return new utils.Interface(_abi) as Archetype_VaultInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Archetype_Vault {
    return new Contract(address, _abi, signerOrProvider) as Archetype_Vault;
  }
}
